/**
 * Gets the platform app name from an url.
 */
const getAppName = (url) => {
  let subdomain;

  if (url) {
    const hostName = url.split('//')[1];
    subdomain = hostName.split('.')[0];
  } else {
    subdomain = window.location.host.split('.')[0];
  }

  if (subdomain.indexOf('-')) {
    return subdomain.split('-')[0];
  }

  return subdomain;
};

const isAuthPath = () => window.location.pathname.includes('/auth');

export default {
  getAppName,
  isAuthPath,
};
